/**
 * Finalised Version — see GLOSSARY.md → Trial Authoring → Finalised Version.
 */
export type FinalisedVersion = string & { readonly __brand: 'FinalisedVersion' };

export const FINALISED_VERSION_FORMAT_GUIDANCE =
  'Use the format v<major>.<minor> with numeric parts and no leading zeros.';

const finalisedVersionPattern = /^v(0|[1-9]\d*)[.](0|[1-9]\d*)$/;

export const createFinalisedVersion = (raw: string): FinalisedVersion => {
  if (!finalisedVersionPattern.test(raw)) {
    throw new Error(`Invalid FinalisedVersion: ${FINALISED_VERSION_FORMAT_GUIDANCE}`);
  }
  return raw as FinalisedVersion;
};

type VersionParts = readonly [major: number, minor: number];

const versionParts = (version: FinalisedVersion): VersionParts => {
  const match = finalisedVersionPattern.exec(version);
  if (match === null) {
    throw new Error(`Invalid FinalisedVersion: ${FINALISED_VERSION_FORMAT_GUIDANCE}`);
  }

  const [, major, minor] = match;
  return [Number(major), Number(minor)];
};

export const compareFinalisedVersions = (
  left: FinalisedVersion,
  right: FinalisedVersion,
): -1 | 0 | 1 => {
  const [leftMajor, leftMinor] = versionParts(left);
  const [rightMajor, rightMinor] = versionParts(right);

  if (leftMajor < rightMajor) return -1;
  if (leftMajor > rightMajor) return 1;
  if (leftMinor < rightMinor) return -1;
  if (leftMinor > rightMinor) return 1;
  return 0;
};
